import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>Wat is creatine en hoe werkt het?</title>
                <link rel="canonical" href={route("blogs.fifteenth")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="WE ARE - personal Training Uden en Schijndel heeft een nieuwe blog, namelijk over creatine. Creatine is een supplement dat door veel krachtsporters wordt gebruikt. Maar wat is creatine eigenlijk en wat doet het met ons wanneer we het supplementeren?"
                />
                <meta
                    property="og:description"
                    content="WE ARE - personal Training Uden en Schijndel heeft een nieuwe blog, namelijk over creatine. Creatine is een supplement dat door veel krachtsporters wordt gebruikt. Maar wat is creatine eigenlijk en wat doet het met ons wanneer we het supplementeren?"
                />
                <meta property="og:url" content={route("blogs.fifteenth")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Wat is creatine en hoe werkt het? - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/werking-creatine.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh]  pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/werking-creatine.webp"
                                    type="image/webp"
                                    alt="Creatine"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/werking-creatine.jpg"
                                    type="image/jpeg"
                                    alt="Creatine"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/werking-creatine.jpg"
                                    alt="Creatine"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Wat is creatine en hoe werkt het?
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        WE ARE - personal Training Uden en Schijndel heeft een
                        nieuwe blog, namelijk over creatine. Creatine is een
                        supplement dat door veel krachtsporters wordt gebruikt.
                        Maar wat is creatine eigenlijk en wat doet het met ons
                        wanneer we het supplementeren?
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Wat is creatine?{" "}
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Creatine is een supplement dat we kunnen nuttigen om ons
                        van meer energie te voorzien. Wat veel mensen niet weten
                        is dat creatine ook een lichaamseigen stof is. Creatine
                        is namelijk een mengselmoes van drie verschillende
                        aminozuren: L- arginine, L- methionine en L- glycine. In
                        de lever en nieren worden deze stoffen omgezet naar
                        creatine zodat het lichaam deze vorm kan gebruiken als
                        energiebron. Het lichaam kan dus zelf creatine aanmaken
                        en een kleine hoeveel voorraad van deze creatine hebben.
                        Dagelijks hebben we ongeveer 1 -3 gram creatine per dag
                        nog om de voorraden aan te vullen in het lichaam. Deze
                        benodigde hoeveelheden verschillen per persoon. Je kunt
                        dit halen uit voeding en het lichaam vult gedeeltelijk
                        deze voorraad zelf aan. Voeding zoals vis maar
                        voornamelijk vlees bevat veel creatine. Een kilo kip
                        bevat als snel 3,8 gram creatine. Het lichaam gebruikt
                        deze vorm als energiebron, voornamelijk korte intensieve
                        inspanningen zoals een sprintje naar de trein!
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hoe werkt creatine?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer je beweegt gebruik je jouw spieren. Dit kost het
                        lichaam energie en hiervoor is ATP
                        (Adenosinetrifosfaat). Hierdoor raken energievoorraden
                        op en dienen ze opnieuw aangevuld te worden. Het lichaam
                        gebruikt hier eiwitten, koolhydraten, vetten en creatine
                        voor. Creatine die we suppletie of via voeding binnen
                        krijgen worden opgenomen in ons darmsysteem om
                        vervolgens vervoerd te worden naar onze cellen zodat we
                        dit kunnen gebruiken om korte intensieve bewegingen te
                        volbrengen. Het herstel van de waardes duurt relatief
                        lang: met 2 minuten is zo'n 84% van het CP niveau
                        hersteld, na 4 minuten is dit 89% en na 8 minuten zijn
                        de volledige waardes weer volledig hersteld.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Effecten die je kunt merken
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer je gebruikt maakt van creatine suppletie kan je
                        merken dat je meer kracht krijgt. Dit is voornamelijk
                        bij korte explosieve bewegingen. Je kunt ook merken dat
                        er meer vetvrije massa erbij komt mede doordat de cellen
                        vocht beginnen aan te trekken door het gebruik creatine.
                        Dit zorgt voor een toename in gewicht en een ‘pomp’ in
                        de spieren. Uiteindelijk zal het ook je spierkracht
                        verhogen. Onderzoeken laten zien dat bij consistent
                        gebruik van creatine het de spierkracht kan verhogen met
                        enkele procenten. Verwacht dus geen grote veranderingen
                        maar alle kleine beetjes helpen!
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Creatine met of zonder laadfase
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        De meningen zijn verschillend over de laadfase van
                        creatine. Om sneller de effecten van creatine te merken
                        wordt er ooit gesproken over een gouden laadfase waarbij
                        je totaal 20 gram creatine per dag neemt verdeeld over
                        meerdere momenten op de dag. Dit doe je ongeveer één
                        week om daarna dit terug te brengen naar 3 – 5 gram per
                        dag. Wanneer je deze laadfase toepast is het belangrijk
                        om voldoende water te drinken omdat creatine namelijk
                        veel vocht aantrekt. Hierdoor kan je een tekort krijgen
                        op andere delen in het lichaam zoals in je maag en
                        darmen. Het gevolg hiervan is dat er krampen kunnen
                        ontstaan.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Een andere manier is om 3 – 5 gram per dag te nemen.
                        Deze manier heeft onze voorkeur om dit de kans op
                        krampen verkleind. Daarnaast laten onderzoeken zien dat
                        deze manier niet minder effectief is dan het gebruik van
                        een laadfase.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Voor wie is creatine aan te raden?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wanneer je een krachtsporter bent die voornamelijk
                        gebruik maak van korte, explosieve bewegingen dan is
                        creatine aan te raden. Ook voor overige krachtsporters
                        is creatine een wettenschappelijk bewezen product! Let
                        wel goed op: door de toename in gewicht kan het een
                        mentale drempel worden voor sporters die juist graag
                        gewicht willen verliezen. Bedenk altijd dat creatine
                        alleen een toename in je vochtbalans geeft, niet in vet!
                        In iedere situatie dien je rekening te houden dat je als
                        persoon ook een non-responder kan zijn. Dit betekent dat
                        je lichaam niet dezelfde effecten vertoond als bij
                        andere. Mocht je al voldoende creatine binnen krijgen
                        door voeding dan heeft extra supplementeren geen zin.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Eindeloze discussie: monohydraat of nitraat?
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Wij vinden dat je het beste kan gaan voor monohydraat.
                        Deze vorm van creatine neemt het lichaam makkelijk op.
                        Het voornaamste verschil tussen monohydraat en nitraat
                        is dat monohydraat vooral zorgt voor de toename in
                        spierkracht en nitraat voor de spierpomp. Een suppletie
                        die bestaat uit een mix van deze twee vormen kan dus
                        geen kwaad zolang jij je er maar goed bij voelt.
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
